import { useCallback } from 'react';

import { useApolloClient } from '@apollo/client/react';

import { setPrefetchedSessionContent } from '@/hooks/sessionContentPrefetchCache';
import { LogSessionContent, SESSION_CONTENT, SESSION_CONTENT_BOUNDED } from '@/hooks/useLogs';
import { computeSessionBoundDate } from '@/util/dateUtils';

export const usePrefetchSessionContent = () => {
  const client = useApolloClient();

  const prefetch = useCallback(
    (sessionId: string, startTime?: string) => {
      const startDate = startTime ? computeSessionBoundDate(startTime) : undefined;
      client
        .query<LogSessionContent>({
          query: startDate ? SESSION_CONTENT_BOUNDED : SESSION_CONTENT,
          variables: startDate ? { sessionId, startDate } : { sessionId },
        })
        .then(({ data }) => {
          const content = data?.rows?.[0];
          if (content) {
            setPrefetchedSessionContent(sessionId, content);
          }
        })
        .catch(() => {});
    },
    [client]
  );

  return prefetch;
};
